import React from "react"
import {
  Section,
  Container,
  M,
  H2BlackTitleMargin,
  PillTag,
  PillTagsContainer,
} from "../../Global"
import ICategory from "./types"
import TrainingCard from "../../Elements/TrainingCard"
import { Description, VideosGrid } from "./styles"

const CategoryComponent = ({ videos, name }: ICategory) => {
  return (
    <Section>
      <Container>
        <M>
          <H2BlackTitleMargin>{name}</H2BlackTitleMargin>
          <PillTagsContainer>
            <PillTag>CARDIO</PillTag>
            <PillTag>INTERWAŁ</PillTag>
            <PillTag>BODY SHAPE</PillTag>
            <PillTag>CARDIO</PillTag>
            <PillTag>INTERWAŁ</PillTag>
            <PillTag>BODY SHAPE</PillTag>
          </PillTagsContainer>
          <Description>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur.
          </Description>
          <VideosGrid>
            {videos.map((c, idx) => (
              <TrainingCard
                key={idx}
                authorName={c.author.name}
                trainingTitle={c.video.name}
                authorPicture={c.author.picture_icon}
                trainingVideo={c.video}
                videoSlug={c.video.slug}
                iFrame={c.video.iFrame}
                price={c.video.price}
                intensity={c.video.intensity}
                rating={c.video.rating}
                lenght={c.video.lenght}
                videoId={c.video.id}
                packageSlug={c.packageSlug}
                isInChallenge={false}
              />
            ))}
          </VideosGrid>
        </M>
      </Container>
    </Section>
  )
}

export default CategoryComponent
